import { render, staticRenderFns } from "./NotificationReadConfirmModal.vue?vue&type=template&id=510f3b42"
import script from "./NotificationReadConfirmModal.vue?vue&type=script&lang=ts"
export * from "./NotificationReadConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports